import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'

export default async function activatedActivity (state, appOptions, lastPage, options) {
  const PresenterControls = (await import(/* webpackChunkName: 'presenter-controls' */ '../../components/presenter_controls')).default

  const view = new PresenterControls({
    model: state.get('user')
  })

  view.on('done', () => store.dispatch(appSlice.pageUpdated(lastPage)))
  return view
}
